import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import "./Css/View.css";
import profile from "./Images/Ellipse 24 (4).png";
import API_BASE from "../config/api";

const API_BASE_URL = `${API_BASE}/`;

const MEDIUM_MAP = {
  1: "मराठी",
  2: "इंग्लिश"
};

const SUBSCRIPTION_MAP = {
  1: "बेसिक",
  2: "स्टॅंडर्ड",
  3: "प्रीमियम"
};

const DURATION_MAP = {
  6: "६ महिने",
  12: "१२ महिने",
  24: "२४ महिने"
};

const SoftwaregEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [software, setSoftware] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [standards, setStandards] = useState([]);

  useEffect(() => {
    if (id) {
      fetchSoftware();
      fetchStandards();
    }
  }, [id]);

  const fetchSoftware = async () => {
    const res = await axios.get(`${API_BASE_URL}api/softwares/${id}`);

    setSoftware({
      ...res.data,
      medium:
        res.data.medium === "Marathi"
          ? 1
          : res.data.medium === "English"
            ? 2
            : null,
      papers: res.data.papers || []
    });
  };

  const fetchStandards = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}api/softwares/standards`
      );
      setStandards(res.data);
    } catch (err) {
      console.error("Error fetching standards", err);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);
    setPreviewImage(URL.createObjectURL(file));
  };

  const uploadImageIfNeeded = async () => {
    if (!imageFile) return software.profilePictureUrl;

    const formData = new FormData();
    formData.append("file", imageFile);

    const res = await axios.post(
      `${API_BASE_URL}api/softwares/upload-image`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data.imageUrl;
  };

  const handleSave = async () => {
    try {
      const imageUrl = await uploadImageIfNeeded();

      const payload = {
        softwareName: software.softwareName,
        profilePictureUrl: imageUrl,
        subscriptionType: software.subscriptionType,
        softwarePrice: software.softwarePrice,
        studentCapacity: software.studentCapacity,
        duration: software.duration,
        medium: software.medium,
        standardId: software.standardId,

        papers: software.papers.map(p => ({
          paperNumber: p.paperNumber,
          subjects: p.subjects.map(s => ({
            name: s.name,
            topics: s.topics.map(t => ({
              name: t.name,
              subTopics: t.subTopics
            }))
          }))
        }))
      };

      await axios.put(`${API_BASE_URL}api/softwares/${id}`, payload);

      navigate("/dashboard/softwaremangment");

    } catch (error) {
      console.error("Update failed", error);
    }
  };

  if (!software) return null;


  const updateSubjectName = (pIndex, sIndex, value) => {
    const updated = [...software.papers];
    updated[pIndex].subjects[sIndex].name = value;

    setSoftware({ ...software, papers: updated });
  };

  const updateTopicName = (pIndex, sIndex, tIndex, value) => {
    const updated = [...software.papers];
    updated[pIndex].subjects[sIndex].topics[tIndex].name = value;

    setSoftware({ ...software, papers: updated });
  };

  const updateSubtopicName = (pIndex, sIndex, tIndex, subIndex, value) => {
    const updated = [...software.papers];
    updated[pIndex].subjects[sIndex].topics[tIndex].subTopics[subIndex] = value;

    setSoftware({ ...software, papers: updated });
  };

  const addSubject = (pIndex) => {
    const updated = [...software.papers];

    updated[pIndex].subjects.push({
      name: "",
      topics: []
    });

    setSoftware({ ...software, papers: updated });
  };

  const addTopic = (pIndex, sIndex) => {
    const updated = [...software.papers];

    updated[pIndex].subjects[sIndex].topics.push({
      name: "",
      subTopics: []
    });

    setSoftware({ ...software, papers: updated });
  };

  const addSubtopic = (pIndex, sIndex, tIndex) => {
    const updated = [...software.papers];

    updated[pIndex].subjects[sIndex].topics[tIndex].subTopics.push("");

    setSoftware({ ...software, papers: updated });
  };

  const deleteSubject = (pIndex, sIndex) => {
    const updated = [...software.papers];
    updated[pIndex].subjects.splice(sIndex, 1);

    setSoftware({ ...software, papers: updated });
  };

  const deleteTopic = (pIndex, sIndex, tIndex) => {
    const updated = [...software.papers];
    updated[pIndex].subjects[sIndex].topics.splice(tIndex, 1);

    setSoftware({ ...software, papers: updated });
  };

  const deleteSubtopic = (pIndex, sIndex, tIndex, subIndex) => {
    const updated = [...software.papers];
    updated[pIndex].subjects[sIndex].topics[tIndex].subTopics.splice(subIndex, 1);

    setSoftware({ ...software, papers: updated });
  };

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          सॉफ्टवेअर व्यवस्थापन &gt;&gt; <span>सॉफ्टवेअर संपादन</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button className="btn primaryy" onClick={handleSave}>
            सेव्ह करा
          </button>
        </div>
      </div>

      <h2>सॉफ्टवेअर संपादन करा</h2>

      {/* Profile Image */}
      <div className="profile-card">
        <div className="profile-img-wrapper">
          <img
            src={
              previewImage
                ? previewImage
                : software.profilePictureUrl
                  ? `${API_BASE_URL}${software.profilePictureUrl}`
                  : profile
            }
            alt="software"
            className="profile-img"
          />

          <label className="edit-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18" fill="none">
              <path d="M2 16H3.425L13.2 6.225L11.775 4.8L2 14.575V16ZM0 18V13.75L13.2 0.575C13.4 0.391667 13.6208 0.25 13.8625 0.15C14.1042 0.05 14.3583 0 14.625 0C14.8917 0 15.15 0.05 15.4 0.15C15.65 0.25 15.8667 0.4 16.05 0.6L17.425 2C17.625 2.18333 17.7708 2.4 17.8625 2.65C17.9542 2.9 18 3.15 18 3.4C18 3.66667 17.9542 3.92083 17.8625 4.1625C17.7708 4.40417 17.625 4.625 17.425 4.825L4.25 18H0Z" fill="#ffffff" />
            </svg>
            <input type="file" accept="image/*" hidden onChange={handleImageChange} />
          </label>
        </div>
      </div>

      {/* Editable Grid */}
      <div className="info-gridd">
        <div className="info-boxx">
          <label>सॉफ्टवेअर नाव</label>
          <input
            value={software.softwareName}
            onChange={(e) =>
              setSoftware({ ...software, softwareName: e.target.value })
            }
          />
        </div>

        <div className="info-boxx">
          <label>इयत्ता</label>
          <select
            value={software.standardId}
            onChange={(e) =>
              setSoftware({ ...software, standardId: Number(e.target.value) })
            }
          >
            <option value="">इयत्ता निवडा</option>
            {standards.map((std) => (
              <option key={std.id} value={std.id}>
                {std.name}
              </option>
            ))}
          </select>
        </div>

        <div className="info-boxx">
          <label>माध्यम</label>
          <select
            value={software.medium ?? ""}
            onChange={(e) =>
              setSoftware({ ...software, medium: Number(e.target.value) })
            }
          >
            <option value="">माध्यम निवडा</option>
            {Object.entries(MEDIUM_MAP).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>

        <div className="info-boxx">
          <label>सबस्क्रिप्शन स्टॅंडर्ड</label>
          <select
            value={software.subscriptionType}
            onChange={(e) =>
              setSoftware({ ...software, subscriptionType: Number(e.target.value) })
            }
          >
            {Object.entries(SUBSCRIPTION_MAP).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>

        <div className="info-boxx">
          <label>सॉफ्टवेअर किंमत</label>
          <input
            type="number"
            value={software.softwarePrice}
            onChange={(e) =>
              setSoftware({ ...software, softwarePrice: Number(e.target.value) })
            }
          />
        </div>

        <div className="info-boxx">
          <label>विद्यार्थी मर्यादा</label>
          <input
            type="number"
            value={software.studentCapacity}
            onChange={(e) =>
              setSoftware({ ...software, studentCapacity: Number(e.target.value) })
            }
          />
        </div>

        <div className="info-boxx">
          <label>सबस्क्रिप्शन कालावधी</label>
          <select
            value={software.duration}
            onChange={(e) =>
              setSoftware({ ...software, duration: Number(e.target.value) })
            }
          >
            {Object.entries(DURATION_MAP).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="paper-section">
        <h3>पेपर संरचना</h3>

        {software.papers?.map((paper, pIndex) => (
          <div key={pIndex} className="paper-box">

            <h4>Paper {paper.paperNumber}</h4>

            {paper.subjects?.map((subject, sIndex) => (
              <div key={sIndex} className="subject-box">

                <input
                  value={subject.name}
                  onChange={(e) =>
                    updateSubjectName(pIndex, sIndex, e.target.value)
                  }
                />

                <button onClick={() => deleteSubject(pIndex, sIndex)}>
                  Delete Subject
                </button>

                {subject.topics?.map((topic, tIndex) => (
                  <div key={tIndex} className="topic-box">

                    <input
                      value={topic.name}
                      onChange={(e) =>
                        updateTopicName(pIndex, sIndex, tIndex, e.target.value)
                      }
                    />

                    <button onClick={() => deleteTopic(pIndex, sIndex, tIndex)}>
                      Delete Topic
                    </button>

                    {topic.subTopics?.map((sub, subIndex) => (
                      <div key={subIndex}>

                        <input
                          value={sub}
                          onChange={(e) =>
                            updateSubtopicName(
                              pIndex,
                              sIndex,
                              tIndex,
                              subIndex,
                              e.target.value
                            )
                          }
                        />

                        <button
                          onClick={() =>
                            deleteSubtopic(pIndex, sIndex, tIndex, subIndex)
                          }
                        >
                          Delete
                        </button>

                      </div>
                    ))}

                    <button onClick={() => addSubtopic(pIndex, sIndex, tIndex)}>
                      + Add Subtopic
                    </button>

                  </div>
                ))}

                <button onClick={() => addTopic(pIndex, sIndex)}>
                  + Add Topic
                </button>

              </div>
            ))}

            <button onClick={() => addSubject(pIndex)}>
              + Add Subject
            </button>

          </div>
        ))}
      </div>
    </div>
  );
};

export default SoftwaregEdit;
